import {BaseComponent} from "../../base.component.js";
import AbTooltip from "../../widgets/tooltip/tooltip.widget.js";

/**
 * @typedef {RenderableProps} _AbBrandImage_Props
 * @property {_BrandPartner} brand
 */

export class AbBrandImage extends BaseComponent {

  /** @type {AbTooltip} */
  _tooltip;

  /**
   * @param {_AbBrandImage_Props} props
   */
  constructor(props) {
    super(props);
    this.state = { };
  }

  setTooltip(tooltip) {
    if (tooltip) {
      this._tooltip = tooltip;
      this._tooltip.setTarget(this.base);
    } else if (this._tooltip) {
      this._tooltip.hide();
    }
  }

  componentWillUnmount() {
    this._tooltip.hide();
    super.componentWillUnmount();
  }

  componentWillUpdate() {
    this._tooltip.hide();
  }

  /**
   * @param {_AbBrandImage_Props} props
   * @returns {ComponentChild}
   */
  render(props, state, ctx) {
    const brand = props.brand;

    if (brand.logoUrl) {
      // temporary fix for local images pointing to old app, which is no longer used
      const idxLocalPort = brand.logoUrl.indexOf(':8888')
      if (idxLocalPort >= 0) {
        brand.logoUrl = brand.logoUrl.replace(':8888', ':4201');
      }
    }

    return (
      <div className={`ab-brand-image ${brand.logoUrl ? 'ab-with-image' : 'ab-with-text'}`} onMouseEnter={() => this._tooltip.show()} onMouseLeave={() => this._tooltip.hide()}>
        {brand.logoUrl && <img src={brand.logoUrl} alt={brand.displayName} onError={() => this.badgeService.notifyImageError(brand.logoUrl)} />}
        {!brand.logoUrl && <div>{brand.displayName}</div> }
        <AbTooltip onRef={tooltip => this.setTooltip(tooltip)} content={<div>{brand.displayName}</div>} />
      </div>
    );
  }

}
